import gettext from '@sdk/lang/gettext';

import config from '../config';

import modalDeleteOrgPasswordUrl from './modal-delete-org-password.html';

export default function DeleteOrgCtrl(
  Authentication,
  Restangular,
  Utils,
  focus,
  $scope,
  $timeout,
  $state,
  $uibModal,
  $uibModalInstance,
  WindowLocation,
  billingInfo
) {
  'ngInject';

  const controller = this;

  controller.submit = submit;
  controller.billingInfo = billingInfo;

  const businessIsSeasonal = 'Our business is seasonal';
  const ourBusinessIsClosing = 'Our business is closing';
  const iAmLeavingTheCompany = 'I am leaving the company';

  controller.reasons = [
    ourBusinessIsClosing,
    businessIsSeasonal,
    iAmLeavingTheCompany,
    'Employee, signed up by mistake',
    'Different product than I expected it to be',
    'Did not understand how the product works',
    'The product is missing essential features',
    'My employees did not use the product',
    'Going to use another scheduling solution',
    'Other',
  ];

  controller.reasonsDict = {
    [ourBusinessIsClosing]: gettext(ourBusinessIsClosing),
    [businessIsSeasonal]: gettext('Our business is seasonal'),
    [iAmLeavingTheCompany]: gettext(iAmLeavingTheCompany),
    'Employee, signed up by mistake': gettext('Employee, signed up by mistake'),
    'Different product than I expected it to be': gettext(
      'Different product than I expected it to be'
    ),
    'Did not understand how the product works': gettext('Did not understand how the product works'),
    'The product is missing essential features': gettext(
      'The product is missing essential features'
    ),
    'My employees did not use the product': gettext('My employees did not use the product'),
    'Going to use another scheduling solution': gettext('Going to use another scheduling solution'),
    Other: gettext('Other'),
  };

  controller.reasonsThatRequireText = [
    'Different product than I expected it to be',
    'Did not understand how the product works',
    'The product is missing essential features',
    'Going to use another scheduling solution',
    'Other',
  ];

  $scope.$watch('ctrl.selectedReason', (val) => {
    if (controller.reasonsThatRequireText.includes(val)) {
      $timeout(() => {
        focus('other-reason');
      });
    }
  });

  const abortOrgDeletionError = 'abort org deletion';

  function maybePauseSubscription() {
    if (
      controller.selectedReason === businessIsSeasonal &&
      !billingInfo?.scheduledToResumeDate &&
      billingInfo?.subscriptionLevel &&
      !billingInfo?.isOnTrial &&
      !controller.pauseOfferDisplayed
    ) {
      controller.pauseModalShown = true;
      controller.onPauseModalClose = (isPaused) => {
        controller.pauseModalShown = false;
        controller.pauseOfferDisplayed = true;

        if (isPaused) {
          $uibModalInstance.close();
          $state.go('account.overview.billing', {}, { reload: true });
        }
      };

      throw abortOrgDeletionError;
    }
  }

  function maybeKeepAccount() {
    if (
      controller.selectedReason === businessIsSeasonal &&
      !billingInfo?.subscriptionLevel &&
      !controller.keepAccountOfferDisplayed
    ) {
      controller.keepAccountModalShown = true;
      controller.keepAccountByTransferOwnership = false;
      controller.onKeepAccountModalClose = (optedToKeepAccount) => {
        controller.keepAccountModalShown = false;
        controller.keepAccountOfferDisplayed = true;

        if (optedToKeepAccount) {
          $uibModalInstance.close();
        }
      };

      throw abortOrgDeletionError;
    }
  }

  function maybeTransferOwnership() {
    if (
      controller.selectedReason === iAmLeavingTheCompany &&
      !controller.keepAccountOfferDisplayed
    ) {
      controller.keepAccountModalShown = true;
      controller.keepAccountByTransferOwnership = true;
      controller.onKeepAccountModalClose = (optedToKeepAccount) => {
        controller.keepAccountModalShown = false;
        controller.keepAccountOfferDisplayed = true;

        if (optedToKeepAccount) {
          $uibModalInstance.close();
          $state.go('dashboard.manage.users.list');
        }
      };

      throw abortOrgDeletionError;
    }
  }

  async function submit() {
    try {
      maybePauseSubscription();
      maybeKeepAccount();
      maybeTransferOwnership();

      await $uibModal
        .open({
          name: 'DeleteOrgConfirmPassword',
          templateUrl: modalDeleteOrgPasswordUrl,
        controller($uibModalInstance) { // eslint-disable-line

            'ngInject';

            focus('password');

            this.submit = async function confirmSubmit(password) {
              this.error = false;
              try {
                const { selectedReason: reason, additionalReason } = controller;
                const text = controller.reasonsThatRequireText.includes(reason)
                  ? additionalReason
                  : undefined;

                await Restangular.all(`organisations/${Authentication.user.org.id}/delete`)
                  .withHttpConfig({ ignoreGlobalErrorHandler: true })
                  .post({ reason, text, password });

                $uibModalInstance.close();
                WindowLocation.href = `${config.SLING_LOGIN_URL}/farewell`;
              } catch (err) {
                this.error = Utils.getErrorMessages(err);
              }
            };
          },
          controllerAs: 'ctrl',
          size: '620',
        })
        .result.ignoreCancel();

      $uibModalInstance.close();
    } catch (e) {
      if (e !== abortOrgDeletionError) {
        throw e;
      }
    }
  }
}
